module.exports = __webpack_public_path__ + "static/cover_photo-d98cfffdb0299a01e2710a1aedb9750d.jpg";